import type { SVGProps } from 'react';

export function ShoppingTrolleyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M1 1h4l2.68 13.39a1 1 0 001 .81h9.72a1 1 0 001-.76L22 5H6" />
      <circle cx="9.5" cy="20.5" r="1.5" />
      <circle cx="18.5" cy="20.5" r="1.5" />
    </svg>
  );
}
